module.exports = __webpack_public_path__ + "img/ueber-uns.54c2e658.png";